import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-024fc852"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-icons-wrapper ml-lg-1 align-items-lg-start align-content-lg-start" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "text-bold ml-1" }
const _hoisted_4 = {
  key: 0,
  class: "product-info-line flex-lg-row align-items-start"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "d-flex flex-column ml-1" }
const _hoisted_7 = {
  key: 1,
  class: "product-info-line flex-lg-row align-items-start"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "text-bold ml-1 text-preline" }
const _hoisted_10 = {
  key: 2,
  class: "product-info-line flex-lg-row"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check text-success mr-1" }, null, -1))
const _hoisted_12 = { class: "text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.duration)
      ? (_openBlock(), _createBlock(_component_Panel, {
          key: 0,
          collapsed: _ctx.datesCollapsed,
          "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.datesCollapsed) = $event))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("i", {
                class: "pi pi-clock text-primary",
                title: _ctx.$t('cart.table.iconDuration_title')
              }, null, 8, _hoisted_2),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.duration), 1)
            ])
          ]),
          icons: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "p-button-text p-panel-header-icon",
              icon: _ctx.datesCollapsed ? 'pi pi-chevron-left' : 'pi pi-chevron-down',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.datesCollapsed = !_ctx.datesCollapsed))
            }, null, 8, ["icon"])
          ]),
          default: _withCtx(() => [
            (_ctx.item.expert?.dates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("i", {
                    class: "pi pi-calendar text-primary",
                    style: {"margin-top":"0.3rem"},
                    title: _ctx.$t('cart.table.iconDates_title')
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.expert?.dates, (date, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "text-bold"
                      }, _toDisplayString(_ctx.formattedBookingDate(date)), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["collapsed"]))
      : _createCommentVNode("", true),
    (_ctx.location)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("i", {
            class: "pi pi-map-marker text-primary",
            style: {"margin-top":"0.3rem"},
            title: _ctx.$t('cart.table.iconLocation_title')
          }, null, 8, _hoisted_8),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.location), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item.expert?.isFlexBooking)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("cart.table.colFlexBooking")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}